import Index from "../../pages/snail/snail_5thSpecial/index";
import Pc from "../../pages/snail/snail_5thSpecial/pc";

const base = "snail_5thSpecial";

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  },
  {
    path: `/${base}/pc*`,
    name: `${base}-pc`,
    component: Pc
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/snail/snail_5thSpecial.js